import { F0Box, F0TagAlert, F0Text } from '@factorialco/f0-react'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'

import type Status from 'modules/integrations_primobox/lib/interfaces/Status'
import { colorFromStatusF0, translateStatus } from 'modules/integrations_primobox/lib/statusHelpers'

interface Props {
  status: Status
}

const StatusTagF0 = ({ status }: Props) => {
  return (
    <F0Box display="flex" flexDirection="row" gap="md" alignItems="center">
      <F0TagAlert level={colorFromStatusF0(status.status)} text={translateStatus(status.status)} />
      <F0Text variant="description" content={dateBackendDateTimeToUI(status.updatedAt)} />
    </F0Box>
  )
}

export default StatusTagF0
